import React, { useEffect } from 'react'
import './sec1.css';
import Spotlight from '../../assets/Spotlight.JPG';
import Crown from '../../assets/About-crown.svg';
import Aim from '../../assets/About-aim.svg';
import Rocket from '../../assets/About-rocket.svg';
import { motion, setDragLock, transform } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Sec1 = () => {
  const { ref, inView } = useInView({
    triggerOnce: false, 
    threshold: 0.2,    
  });

  const textVariant = {
    hidden: { opacity: 0, y: 50, scale: 0.8 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9 }, scale: 1 }
  };

  return (
    <div>
      <div className="spotlight">
        <img className="spotlight-img" src={Spotlight} alt="Spotlight"/>
        <h1 className="Desktopview">QuizInc<br/>NIT Durgapur</h1>
        <h1 className="Mobileview">QuizInc<br/>NIT Durgapur</h1>
      </div>
      <h1 className='about'>About QuizInc</h1>
      <motion.div 
        className="about-csi"
        ref={ref}
        initial="hidden"
        animate={inView ? 'visible' : 'hidden'}
        variants={textVariant}
      >
        <div className="about-csi-content">
            <img className="about-csi-content-img" src={Crown} alt="Crown"/>
            <h1 className="about-csi-content-h1" >Value</h1>
            <p className="about-csi-content-p" >One of the oldest and most esteemed clubs in the institution, fostering a legacy of curiosity and knowledge.</p>
        </div>
        <div className="about-csi-content">
            <img className="about-csi-content-img" src={Aim} alt="Aim"/>
            <h1 className="about-csi-content-h1" >Quest</h1>
            <p className="about-csi-content-p" >Where knowledge meets creativity through diverse events, thought-provoking discussions, and a culture of intellectual growth.</p>
        </div>
        <div className="about-csi-content">
            <img className="about-csi-content-img" src={Rocket} alt="Rocket"/>
            <h1 className="about-csi-content-h1" >Connect</h1>
            <p className="about-csi-content-p" >Forge connections that go beyond the quiz arena. Collaborate with like-minded enthusiasts and be part of a vibrant community driven by a shared passion for curiosity and discovery.</p>
        </div>
      </motion.div>
    </div>
  )
}

export default Sec1